import { SxProps } from '@mui/system'
import { theme } from 'src/providers/ThemeProvider'

type DialogElements = {
  container: SxProps
  content: SxProps
  sendButton: SxProps
  stageListItem: SxProps
  row1: SxProps
  rowProgress: SxProps
  progress: SxProps
  statusText: SxProps
  statusMessage: SxProps
  statusIcon: SxProps
  errorInfo: SxProps
  loader: SxProps
}

export const LoginStagesStyles: DialogElements = {
  container: {
    '&.css-fihatw-MuiPaper-root-MuiDialog-paper': {
      maxWidth: '700px'
    },
    '& .MuiDialog-container .MuiDialog-paper': {
      borderRadius: '8px',
      padding: 0,
      paddingBottom: '24px'
    }
  },
  content: {
    padding: '0 24px 24px 24px',
    marginTop: '12px',

    '& ul': {
      padding: 0,
      listStyleType: 'none'
    },

    '& .MuiDialogActions-root': {
      padding: '50px'
    }
  },

  stageListItem: {
    display: 'flex',
    flexDirection: 'column',
    aligItems: 'center',
    marginBottom: theme.spacing(3),

    '&:last-child': {
      marginBottom: 0
    }
  },

  row1: {
    display: 'flex',
    flexDirection: 'row',
    marginBottom: theme.spacing(1)
  },

  rowProgress: {
    height: 4,
    borderRadius: '8px',
    backgroundColor: theme.colors.gray300
  },

  progress: {
    width: '0%',
    height: 4,
    borderRadius: '8px',
    transition: 'width 0.25s ease-in-out',

    '.initial &': {
      width: '0%'
    },

    '.processing &': {
      width: '60%',
      backgroundColor: theme.colors.seaGreen100
    },

    '.success &': {
      width: '100%',
      backgroundColor: theme.colors.seaGreen100
    },

    '.error &': {
      width: '100%',
      backgroundColor: theme.colors.persianRed100
    }
  },

  statusText: {
    flex: '1 1 auto',
    height: 20,
    margin: 0,
    fontFamily: theme.corporate.primaryFont,
    fontSize: '18px',
    fontWeight: 500,
    color: theme.colors.gray900,
    lineHeight: '20px',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },

  statusIcon: {
    flex: '0 0 auto',
    alignSelf: 'center',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',

    '& .MuiSvgIcon-root': {
      fontSize: '16px'
    }
  },

  sendButton: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginRight: '20px'
  },

  statusMessage: {
    fontFamily: theme.corporate.primaryFont,
    fontSize: '16px',
    fontWeight: 400,
    color: theme.colors.gray600,
    lineHeight: '20px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    margin: theme.spacing(0, 0.5),

    '&.processing': {
      color: theme.colors.gray600
    },

    '&.success': {
      color: theme.corporate.successColor
    },

    '&.error': {
      color: theme.corporate.errorColor
    }
  },

  errorInfo: {
    margin: '8px 0 0 0',
    fontFamily: theme.corporate.primaryFont,
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '18px',
    color: theme.corporate.errorColor
  },

  loader: {
    width: 16,
    height: 16,
    fontSize: '16px',

    '& > .MuiBox-root': {
      width: 16,
      height: 16,
      display: 'flex',
      alignItems: 'center'
    },

    '& .spinner-border.corporativo': {
      width: 16,
      height: 16,
      border: `1px solid ${theme.colors.gray900}`,
      borderRightColor: 'transparent'
    }
  }
}
